import ReactMarkdown from 'react-markdown';
import { cn } from '@/lib/utils';

interface MarkdownContentProps {
  content: string;
  className?: string;
}

export function MarkdownContent({ content, className }: MarkdownContentProps) {
  return (
    <div
      className={cn(
        'prose prose-invert prose-sm max-w-none',
        // Headings
        'prose-headings:font-semibold prose-headings:text-foreground prose-headings:mt-6 prose-headings:mb-3',
        'prose-h1:text-xl prose-h2:text-lg prose-h3:text-base',
        // Body text
        'prose-p:text-muted-foreground prose-p:leading-relaxed prose-p:my-3',
        // Links
        'prose-a:text-orange-400 prose-a:no-underline hover:prose-a:underline',
        // Strong / em
        'prose-strong:text-foreground prose-strong:font-semibold',
        'prose-em:text-muted-foreground',
        // Lists
        'prose-ul:text-muted-foreground prose-ol:text-muted-foreground',
        'prose-li:my-1',
        // Code inline
        'prose-code:text-orange-300 prose-code:bg-white/[0.06] prose-code:rounded prose-code:px-1.5 prose-code:py-0.5 prose-code:text-xs prose-code:font-mono prose-code:before:content-none prose-code:after:content-none',
        // Code blocks
        'prose-pre:bg-white/[0.03] prose-pre:border prose-pre:border-white/[0.06] prose-pre:rounded-xl prose-pre:p-4',
        'prose-pre:text-sm prose-pre:font-mono',
        // Blockquote
        'prose-blockquote:border-l-orange-500/40 prose-blockquote:text-muted-foreground prose-blockquote:not-italic',
        // HR
        'prose-hr:border-white/[0.06]',
        // Tables
        'prose-th:text-foreground prose-td:text-muted-foreground',
        className,
      )}
    >
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
}
